module.exports = __webpack_public_path__ + "img/arrow.214804e5.svg";